/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_3_QInputs */

const en_mk_faq_3_q = /** @type {(inputs: Mk_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens if an agent gets something wrong?`)
};

const id_mk_faq_3_q = /** @type {(inputs: Mk_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana kalau agen mengerjakan sesuatu dengan salah?`)
};

/**
* | output |
* | --- |
* | "What happens if an agent gets something wrong?" |
*
* @param {Mk_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_3_q = /** @type {((inputs?: Mk_Faq_3_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_3_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_3_q(inputs)
	return en_mk_faq_3_q(inputs)
});